<script setup lang="ts">
import {
  exitFullScreenMode,
  fullScreenModeState,
  requestFullScreenMode,
} from "../../../../states/fullScreenMode";
import BasePopoverItem from "./BasePopoverItem.vue";
import RequestFullScreen20 from "../../../icons/RequestFullScreen20.vue";
import ExitFullScreen20 from "../../../icons/ExitFullScreen20.vue";
import { locale } from "../../../../locale";

const props = defineProps<{
  close: () => void;
}>();
const request = () => {
  requestFullScreenMode();
  props.close();
};
const exit = () => {
  exitFullScreenMode();
  props.close();
};
</script>
<template>
  <BasePopoverItem
    :text="
      fullScreenModeState
        ? locale.tooltips.exitFullscreen
        : locale.tooltips.enterFullscreen
    "
    @click.stop="
      () => {
        if (fullScreenModeState) {
          exit();
        } else {
          request();
        }
      }
    "
  >
    <RequestFullScreen20 v-if="!fullScreenModeState" />
    <ExitFullScreen20 v-else />
  </BasePopoverItem>
</template>
